export const getters = {
  REGIONS: (state) => state.regions,
  CATEGORIES: (state) => state.categories,
  CITIES: (state) => state.cities,
  TASKS: (state) => state.tasks,
  COUNTRIES: (state) => state.countries,
  DIRECTIONS: (state) => state.directions,
}
